import { z } from 'zod';
import { formatPhoneNumber } from './client';

export function isEmail(value: unknown): boolean {
  return /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/.test(
    String(value),
  );
}

export function isPositiveNumber(value: unknown): boolean {
  return z.coerce.number().positive().safeParse(value).success;
}

export function isValidPhoneNumber(value: unknown): boolean {
  const phoneNumber = formatPhoneNumber(String(value));
  return isPositiveNumber(phoneNumber);
}
